import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title \"Loading\"}}\n\n<LoadingScreen/>\n\n{{outlet}}\n",{ moduleName: "seshy/templates/authenticated/loading.hbs" })